// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InputBarBlue {
    border: none;
    outline: none;
    border: 1px solid var(--InputBarBlueBorderColor);
    background-color: var(--InputBarBlueBackground);
    min-width: 450px;
    margin: 4px 20px;
    padding: 8px;
    color: white;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    font-family: var(--googleFont);
}

.InputBarBlue:focus {
    border: 1px solid var(--InputBarBlueOnFocus);
}

.InputBarBlue::-webkit-input-placeholder {
    color: gray;
    opacity: 0.8;
}

.InputBarBlueNoUpdate {
    border: none;
    outline: none;
    border: 1px solid var(--InputBarBlueBackground);
    background-color: var(--InputBarBlueOnFocus);
    min-width: 450px;
    padding: 8px;
    color: white;
    margin: 4px 20px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    font-family: var(--googleFont);
}

.InputBarBlueError {
    border: none;
    outline: none;
    border-bottom: 1px solid var(--InputBarBlueBorderColor);
    background-color: var(--InputBarBlueOnError);
    min-width: 450px;
    padding: 8px;
    color: white;
    margin: 4px 20px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    font-family: var(--googleFont);
}

.InputBarBlueSucceeded {
    border: none;
    outline: none;
    border: 1px solid var(--InputBarBlueBorderColor);
    background-color: var(--InputBarBlueOnSucces);
    color: white;
    min-width: 450px;
    padding: 8px;
    margin: 4px 20px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    font-family: var(--googleFont);
}

.InputBarColorSwitch {
    border: none;
    outline: none;
    border: 1px solid var(--InputBarBlueBorderColor);
    background-color: var(--InputBarBlueBorderColor);
    min-width: 450px;
    margin: 4px 20px;
    padding: 8px;
    color: white;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    font-family: var(--googleFont);
}

.InputBarColorSwitch:focus {
    border: 1px solid var(--InputBarBlueOnSucces);
}

@media only screen and (max-width: 930px) {
    .InputBarColorSwitch {
        min-width: 0px;
        margin: 2px 2px;
        width: 20em;
    }

    .InputBarBlue {
        min-width: 0px;
        margin: 2px 2px;
        width: 20em;
    }

    .InputBarBlueNoUpdate {
        min-width: 0px;
        margin: 2px 2px;
        width: 20em;
    }

    .InputBarBlueError {
        min-width: 0px;
        margin: 2px 2px;
        width: 20em;
    }

    .InputBarBlueSucceeded {
        min-width: 0px;
        margin: 2px 2px;
        width: 20em;
    }
}

@media only screen and (max-width: 830px) {
    .InputBarColorSwitch {
        min-width: 0px;
        margin: 2px 2px;
    }

    .InputBarBlue {
        min-width: 0px;
        margin: 2px 2px;
    }

    .InputBarBlueNoUpdate {
        min-width: 0px;
        margin: 2px 2px;
    }

    .InputBarBlueError {
        min-width: 0px;
        margin: 2px 2px;
    }

    .InputBarBlueSucceeded {
        min-width: 0px;
        margin: 2px 2px;
    }
}

@media only screen and (max-width: 590px) {
    .InputBarColorSwitch {
        min-width: 0px;
        margin: 2px 2px;
        width: 10em;
    }

    .InputBarBlue {
        min-width: 0px;
        margin: 2px 2px;
        width: 10em;
    }

    .InputBarBlueNoUpdate {
        min-width: 0px;
        margin: 2px 2px;
        width: 10em;
    }

    .InputBarBlueError {
        min-width: 0px;
        margin: 2px 2px;
        width: 10em;
    }

    .InputBarBlueSucceeded {
        min-width: 0px;
        margin: 2px 2px;
        width: 10em;
    }
}

@media only screen and (max-width: 320px) {
    .InputBarBlueSmall {
        transform: scale(0.8);
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/InputBar/InputBar.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,gDAAgD;IAChD,+CAA+C;IAC/C,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,2BAA2B;IAC3B,4BAA4B;IAC5B,8BAA8B;AAClC;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,+CAA+C;IAC/C,4CAA4C;IAC5C,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,2BAA2B;IAC3B,4BAA4B;IAC5B,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,uDAAuD;IACvD,4CAA4C;IAC5C,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,2BAA2B;IAC3B,4BAA4B;IAC5B,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,gDAAgD;IAChD,6CAA6C;IAC7C,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,2BAA2B;IAC3B,4BAA4B;IAC5B,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,gDAAgD;IAChD,gDAAgD;IAChD,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,2BAA2B;IAC3B,4BAA4B;IAC5B,8BAA8B;AAClC;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI;QACI,cAAc;QACd,eAAe;QACf,WAAW;IACf;;IAEA;QACI,cAAc;QACd,eAAe;QACf,WAAW;IACf;;IAEA;QACI,cAAc;QACd,eAAe;QACf,WAAW;IACf;;IAEA;QACI,cAAc;QACd,eAAe;QACf,WAAW;IACf;;IAEA;QACI,cAAc;QACd,eAAe;QACf,WAAW;IACf;AACJ;;AAEA;IACI;QACI,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,eAAe;QACf,WAAW;IACf;;IAEA;QACI,cAAc;QACd,eAAe;QACf,WAAW;IACf;;IAEA;QACI,cAAc;QACd,eAAe;QACf,WAAW;IACf;;IAEA;QACI,cAAc;QACd,eAAe;QACf,WAAW;IACf;;IAEA;QACI,cAAc;QACd,eAAe;QACf,WAAW;IACf;AACJ;;AAEA;IACI;QACI,qBAAqB;IACzB;AACJ","sourcesContent":[".InputBarBlue {\n    border: none;\n    outline: none;\n    border: 1px solid var(--InputBarBlueBorderColor);\n    background-color: var(--InputBarBlueBackground);\n    min-width: 450px;\n    margin: 4px 20px;\n    padding: 8px;\n    color: white;\n    border-top-left-radius: 5px;\n    border-top-right-radius: 5px;\n    font-family: var(--googleFont);\n}\n\n.InputBarBlue:focus {\n    border: 1px solid var(--InputBarBlueOnFocus);\n}\n\n.InputBarBlue::-webkit-input-placeholder {\n    color: gray;\n    opacity: 0.8;\n}\n\n.InputBarBlueNoUpdate {\n    border: none;\n    outline: none;\n    border: 1px solid var(--InputBarBlueBackground);\n    background-color: var(--InputBarBlueOnFocus);\n    min-width: 450px;\n    padding: 8px;\n    color: white;\n    margin: 4px 20px;\n    border-top-left-radius: 5px;\n    border-top-right-radius: 5px;\n    font-family: var(--googleFont);\n}\n\n.InputBarBlueError {\n    border: none;\n    outline: none;\n    border-bottom: 1px solid var(--InputBarBlueBorderColor);\n    background-color: var(--InputBarBlueOnError);\n    min-width: 450px;\n    padding: 8px;\n    color: white;\n    margin: 4px 20px;\n    border-top-left-radius: 5px;\n    border-top-right-radius: 5px;\n    font-family: var(--googleFont);\n}\n\n.InputBarBlueSucceeded {\n    border: none;\n    outline: none;\n    border: 1px solid var(--InputBarBlueBorderColor);\n    background-color: var(--InputBarBlueOnSucces);\n    color: white;\n    min-width: 450px;\n    padding: 8px;\n    margin: 4px 20px;\n    border-top-left-radius: 5px;\n    border-top-right-radius: 5px;\n    font-family: var(--googleFont);\n}\n\n.InputBarColorSwitch {\n    border: none;\n    outline: none;\n    border: 1px solid var(--InputBarBlueBorderColor);\n    background-color: var(--InputBarBlueBorderColor);\n    min-width: 450px;\n    margin: 4px 20px;\n    padding: 8px;\n    color: white;\n    border-top-left-radius: 5px;\n    border-top-right-radius: 5px;\n    font-family: var(--googleFont);\n}\n\n.InputBarColorSwitch:focus {\n    border: 1px solid var(--InputBarBlueOnSucces);\n}\n\n@media only screen and (max-width: 930px) {\n    .InputBarColorSwitch {\n        min-width: 0px;\n        margin: 2px 2px;\n        width: 20em;\n    }\n\n    .InputBarBlue {\n        min-width: 0px;\n        margin: 2px 2px;\n        width: 20em;\n    }\n\n    .InputBarBlueNoUpdate {\n        min-width: 0px;\n        margin: 2px 2px;\n        width: 20em;\n    }\n\n    .InputBarBlueError {\n        min-width: 0px;\n        margin: 2px 2px;\n        width: 20em;\n    }\n\n    .InputBarBlueSucceeded {\n        min-width: 0px;\n        margin: 2px 2px;\n        width: 20em;\n    }\n}\n\n@media only screen and (max-width: 830px) {\n    .InputBarColorSwitch {\n        min-width: 0px;\n        margin: 2px 2px;\n    }\n\n    .InputBarBlue {\n        min-width: 0px;\n        margin: 2px 2px;\n    }\n\n    .InputBarBlueNoUpdate {\n        min-width: 0px;\n        margin: 2px 2px;\n    }\n\n    .InputBarBlueError {\n        min-width: 0px;\n        margin: 2px 2px;\n    }\n\n    .InputBarBlueSucceeded {\n        min-width: 0px;\n        margin: 2px 2px;\n    }\n}\n\n@media only screen and (max-width: 590px) {\n    .InputBarColorSwitch {\n        min-width: 0px;\n        margin: 2px 2px;\n        width: 10em;\n    }\n\n    .InputBarBlue {\n        min-width: 0px;\n        margin: 2px 2px;\n        width: 10em;\n    }\n\n    .InputBarBlueNoUpdate {\n        min-width: 0px;\n        margin: 2px 2px;\n        width: 10em;\n    }\n\n    .InputBarBlueError {\n        min-width: 0px;\n        margin: 2px 2px;\n        width: 10em;\n    }\n\n    .InputBarBlueSucceeded {\n        min-width: 0px;\n        margin: 2px 2px;\n        width: 10em;\n    }\n}\n\n@media only screen and (max-width: 320px) {\n    .InputBarBlueSmall {\n        transform: scale(0.8);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
